import React, {useState} from "react";
import s from "../../TextEditorPage.module.css";
import PostScript from "../PostScript";
import {useSelector} from "react-redux";
import {selectCurrentProject, selectIsPostButtonVisible} from "../../../../store/selectors/projectSelectors";
interface PostButtonProps {
    postText: string;
    image: string|null;
}
const PostButton: React.FC<PostButtonProps>=({postText,image})=>{
    const isPostButtonVisible = useSelector(selectIsPostButtonVisible);
    const currentProject=useSelector(selectCurrentProject);
    const [isPostModal, setIsPostModal] = useState<boolean>(false);

    const handleModalClose = () => {
        setIsPostModal(false)
    };
    const buttonTextMap: Record<string, string> = {
        twitter: 'Post on Twitter',
        linkedin: 'Post on LinkedIn',
        facebook: 'Post on Facebook',
        instagram: 'Post on Instagram',
    };

    const buttonText = buttonTextMap[currentProject?.content_type||0] || 'Post on Social';

    return(<>
        {isPostButtonVisible &&
            <button className={s.post_btn}
                    onClick={()=>setIsPostModal(true)}
            > {buttonText}</button>}
        <PostScript header={buttonText} isShowModal={isPostModal} onClose={handleModalClose} postText={postText} image={image}/>
    </>)
}
export default PostButton;